<router-outlet></router-outlet>

<!-- Add this overlay spinner markup to your template -->
<div class="loading-overlay" *ngIf="isProfileLoading">
  <div class="loading-spinner">
    <div class="spinner"></div>
    <p class="loading-text">Loading your profile...</p>
  </div>
</div>